import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useStatus() {
  return useQuery({
    queryKey: ["status"],
    queryFn: api.status.get,
    refetchInterval: 10_000,
    retry: false,
  });
}
